import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'offers/clone-offer/:code',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const Offer = require('./containers/CloneOffer').default;
        cb(null, Offer)
      }, 'offer')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/CloneOffer/index.js